<template>
  <div class="login-container">
    <div class="login-box">
      <h2>管理后台登录</h2>
      <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" @keyup.enter.native="handleLogin">
        <el-form-item prop="account">
          <el-input 
            v-model="loginForm.account" 
            prefix-icon="el-icon-user" 
            placeholder="请输入管理员账号">
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input 
            v-model="loginForm.password" 
            prefix-icon="el-icon-lock" 
            placeholder="请输入密码" 
            show-password>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button 
            :loading="loading" 
            type="primary" 
            class="login-button" 
            @click="handleLogin">
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import adminApi from '../../api/adminApi'
import { setTokenByRole } from '@/utils/request'

export default {
  name: 'AdminLogin',
  data() {
    return {
      loginForm: {
        account: '',
        password: ''
      },
      loginRules: {
        account: [
          { required: true, message: '请输入管理员账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少6个字符', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          adminApi.adminLogin(this.loginForm)
            .then(res => {
              this.$message.success('登录成功')
              // 存储token和角色信息
              localStorage.setItem('currentRole', 'admin')
              localStorage.setItem('userRole', 'admin')
              // 使用命名空间方式存储token
              setTokenByRole(res.token || '', 'admin')
              localStorage.setItem('token', res.token || '') // 保留兼容性
              // 登录成功后跳转到管理后台首页
              this.$router.push('/admin/dashboard')
            })
            .catch(err => {
              this.$message.error(err.message || '登录失败，请检查账号密码')
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f0f2f5;
}
.login-box {
  width: 400px;
  padding: 30px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.login-box h2 {
  text-align: center;
  margin-bottom: 30px;
  color: #409EFF;
}
.login-button {
  width: 100%;
}
</style> 